// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/stepper.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/stepper.tsx");
  import.meta.hot.lastModified = "1717702442197.402";
}
// REMIX HMR END

// components/Stepper.tsx
import React from 'react';
const Stepper = ({
  steps,
  currentStep
}) => {
  return <div className="flex space-x-4">
            <ol className="space-y-4 w-[100%]">
                {steps.map((step, index) => <div key={index} className={`w-full p-4 border rounded-lg ${index < currentStep ? 'text-[#083d78] border-[#083d78]' : index === currentStep ? 'text-[#083d78] border-[#de782d]' : 'text-gray-300 border-gray-300'} `} role="alert">
                        <div className="flex items-center justify-between">
                            <span className="sr-only">{step}</span>
                            <h3 className="font-medium">{index + 1 + ". " + step}</h3>
                            <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12">
                                <path stroke={index < currentStep ? 'green' : index === currentStep ? '#de782d' : "currentColor"} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={index < currentStep ? "M1 5.917 5.724 10.5 15 1.5" : index === currentStep ? "M1 5h12m0 0L9 1m4 4L9 9" : ""} />
                            </svg>
                        </div>
                    </div>)}
            </ol>
        </div>;
};
_c = Stepper;
export default Stepper;
var _c;
$RefreshReg$(_c, "Stepper");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;